var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.currentField.label,"label-width":_vm.currentField.labelWidth + 'px'}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":_vm.currentField.isPlaceholderVisible ? _vm.currentField.placeholder : ''},model:{value:(_vm.textarea),callback:function ($$v) {_vm.textarea=$$v},expression:"textarea"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }